export const ALL_CONTACTS_IMAGE_URL = 'https://storage.googleapis.com/aspirex-static-files/home-page/All_People.png';
export const AUTOMATION_IMAGE_URL = 'https://storage.googleapis.com/aspirex-static-files/automation.svg';
